<template>
    <el-container>
        <fhead></fhead>
        <el-main>
            <el-breadcrumb class="center" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">{{$t('l.home')}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{$t('l.peer.txt')}}</el-breadcrumb-item>
            </el-breadcrumb>
            <el-card class="box-card center" style="margin-top: 16px">
                <div slot="header" class="clearfix">
                    <span>{{$t('l.peer.txt')}} （ {{peers.length}} ）</span>
                    <div style="float: right;margin-top: -10px">
                        <el-button @click="drawer = true" type="primary" icon="el-icon-circle-plus-outline">
                            {{$t('l.peer.txt1')}}
                        </el-button>

                    </div>
                </div>
                <el-table class="center"
                          v-loading="peersLoading"
                          stripe
                          :data="peers"
                          style="width: 100%">
                    <el-table-column
                            label="id"
                            width="60">
                        <template slot-scope="scope">
                            {{scope.$index+1}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="ip"
                            :label="$t('l.peer.txt2')"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            prop="addr"
                            :label="$t('l.peer.txt3')"
                            width="280">
                    </el-table-column>
                    <el-table-column
                            :label="$t('l.peer.txt4')"
                            width="120">
                        <template slot-scope="scope">
                            {{scope.row.rewarddate}} Day
                        </template>
                    </el-table-column>
                    <el-table-column
                            :label="$t('l.peer.txt5')"
                            width="120">
                        <template slot-scope="scope">
                            {{scope.row.reward}} Hebe
                        </template>
                    </el-table-column>
                    <el-table-column
                            :label="$t('l.peer.txt6')"
                            width="120">
                        <template slot-scope="scope">
                            {{scope.row.pledge}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            :label="$t('l.peer.txt7')"
                            width="120">
                        <template slot-scope="scope">
                            {{scope.row.server}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            :label="$t('l.peer.txt8')"
                            width="180"
                    >
                        <template slot-scope="scope">
                            {{scope.row.date}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            width="60"
                    >
                        <template slot-scope="scope">
                            <el-link @click="detail(scope.row)" type="primary">明细</el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
            <el-drawer
                    :title="$t('l.peer.txt1')"
                    :visible.sync="drawer"
                    :direction="direction"
                    :before-close="handleClose">
                <div>
                    <el-alert
                            :title="$t('l.peer.txt9')"
                            type="success"
                            :closable="false">
                    </el-alert>
                    <div style="margin-top: 10px">
                        <el-form v-loading="loading1"
                                 ref="form" :model="form" label-width="80px">
                            <el-form-item :label="$t('l.peer.txt10')">
                                <el-select v-model="form.region" :placeholder="$t('l.peer.txt11')">
                                    <el-option :label="$t('l.peer.txt12')" value="o"></el-option>
                                    <el-option :label="$t('l.peer.txt13')" value="l"></el-option>
                                </el-select>
                            </el-form-item>
                            <div v-if="form.region=='o'">
                                <el-form-item :label="$t('l.peer.txt14')">
                                    <el-input :placeholder="$t('l.peer.txt15')" v-model="form.ip"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('l.peer.txt16')">
                                    <el-button @click="test1" type="primary">{{$t('l.peer.txt17')}}</el-button>
                                </el-form-item>
                            </div>
                            <div v-if="form.region=='l'">
                                <el-form-item :label="$t('l.peer.txt16')">
                                    <el-button @click="test" type="primary">{{$t('l.peer.txt17')}}</el-button>
                                </el-form-item>
                            </div>
                            <div v-if="is">
                                <el-form-item :label="$t('l.peer.txt18')">
                                    {{form.ip}}
                                </el-form-item>
                                <el-form-item :label="$t('l.peer.txt19')">
                                    {{form.addr}}
                                </el-form-item>
                                <el-form-item :label="$t('l.peer.txt20')">
                                    {{form.date}}
                                </el-form-item>
                            </div>
                            <div v-if="form.addr!=''">
                                <el-form-item>
                                    <el-button type="primary" @click="onSubmit">{{$t('l.peer.txt21')}}</el-button>
                                    <el-button @click="drawer=false">{{$t('l.peer.txt22')}}</el-button>
                                </el-form-item>
                            </div>
                        </el-form>
                    </div>
                </div>
            </el-drawer>
            <el-drawer
                    :title="detatitle"
                    :visible.sync="drawer1"
                    :direction="direction1"
            >
                <el-table class="center"
                          v-loading="peersLoading1"
                          stripe
                          :data="peerslist"
                          style="width: 100%">
                    <el-table-column
                            label="id"
                            width="60">
                        <template slot-scope="scope">
                            {{scope.$index+1}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="ip"
                            :label="$t('l.peer.txt2')"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="sum"
                            :label="$t('l.peer.txt5')"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            :label="'hash'"
                            >
                        <template slot-scope="scope">
                            <el-link :href="'https://block.hebeblock.com/#/transaction/'+scope.row.hash+'?type=Hebe'" target="_blank" type="primary">
                                {{scope.row.hash}}
                            </el-link>
                        </template>
                    </el-table-column>
                </el-table>

            </el-drawer>
        </el-main>

        <el-footer class="footer">
            COPYRIGHT © 2018. ALL RIGHTS RESERVED. DESIGNED BY
            <a target="_blank" href="https://hebeblock.com/">HEBEBLOCK</a>
        </el-footer>
    </el-container>
</template>


<script>
    import fhead from '../fhead.vue';

    export default {
        name: 'peers',
        components: {
            fhead
        },
        data() {
            return {
                drawer1: false,
                direction1: "ltr",
                loading1: false,
                peerslist: [],
                is: false,
                peersLoading1: true,
                peersLoading: true,
                peers: [],
                drawer: false,
                direction: 'ltr',
                form: {
                    region: 'l',
                    addr: '',
                    ip: '',
                    date: '',
                },
                detatitle: ''
            }
        },
        methods: {
            detail(item) {
                this.drawer1 = true
                this.detatitle = item.addr
                this.peersLoading1=true
                this.$ajax({
                    method: 'get',
                    url: 'http://apis.hebe.cc/peer/listhash?addr=' + item.addr,
                }).then(response => {
                    this.peerslist = response
                    this.peersLoading1=false
                });
            },
            test1() {
                this.loading1 = true

                this.$ajax({
                    method: 'get',
                    url: 'http://111.231.76.75:8082/hebe?requestType=getPeer&peer=' + this.form.ip
                }).then(res => {
                    this.loading1 = false
                    if (res.errorDescription) {
                        this.is = false
                        this.loading1 = false
                        this.$alert(this.$t('l.peer.txt25'), this.$t('l.peer.txt23'), {
                            confirmButtonText: this.$t('l.peer.txt24'),
                        });
                    } else {
                        this.is = true
                        this.form.addr = res.platform;
                        this.form.ip = res.address;
                        this.form.date = this.$g.wallet.formatDateTime(res.lastUpdated, (this.$store.state.epochBeginning - 500))
                    }
                    this.$ajax({
                        method: 'get',
                        url: 'http://' + this.form.ip + ':8082/hebe?requestType=getBlock',
                    }, {}, {timeout: 3000}).then(ress => {
                        if (ress.errorDescription) {
                            this.$alert(this.$t('l.peer.txt26'), this.$t('l.peer.txt23'), {
                                confirmButtonText: this.$t('l.peer.txt24'),
                            });
                        }
                    }).catch(err => {
                        this.$alert(this.$t('l.peer.txt27'), this.$t('l.peer.txt23'), {
                            confirmButtonText: this.$t('l.peer.txt24'),
                        });
                    })
                })
            },

            test() {
                this.loading1 = true

                this.$ajax({
                    method: 'get',
                    url: 'http://111.231.76.75:8082/hebe?requestType=getMyInfo'
                }).then(response => {
                    if (response.host) {
                        this.$ajax({
                            method: 'get',
                            url: 'http://111.231.76.75:8082/hebe?requestType=getPeer&peer=' + response.host
                        }).then(res => {
                            this.loading1 = false
                            if (res.errorDescription) {
                                this.is = false
                                this.loading1 = false
                                this.$alert(this.$t('l.peer.txt25'), this.$t('l.peer.txt23'), {
                                    confirmButtonText: this.$t('l.peer.txt24'),
                                });
                            } else {
                                this.is = true
                                this.form.addr = res.platform;
                                this.form.ip = res.address;
                                this.form.date = this.$g.wallet.formatDateTime(res.lastUpdated, (this.$store.state.epochBeginning - 500))

                            }
                        })
                    } else {
                        this.loading1 = false
                        this.$alert(this.$t('l.peer.txt28'), this.$t('l.peer.txt23'), {
                            confirmButtonText: this.$t('l.peer.txt24'),
                        });
                    }
                    console.log(response.host);
                }).catch(err => {
                    this.loading1 = false
                    this.$alert(this.$t('l.peer.txt29'), this.$t('l.peer.txt23'), {
                        confirmButtonText: this.$t('l.peer.txt24'),
                    });
                })
            },
            onSubmit() {
                this.loading1 = true
                this.$ajax({
                    method: 'post',
                    url: 'http://apis.hebe.cc/peer',
                    data: {"ip": this.form.ip}
                }).then(response => {
                    this.loading1 = false
                    this.$alert(response, this.$t('l.peer.txt23'), {
                        confirmButtonText: this.$t('l.peer.txt24'),
                    });
                });
            },
            handleClose(done) {
                done();
                this.load()
            },
            load() {
                this.peersLoading = true;
                this.$ajax({
                    method: 'get',
                    url: 'http://apis.hebe.cc/peer/list',
                }).then(response => {
                    this.peersLoading = false;
                    this.peers = response
                });
            }
        },
        created: function () {
            this.load()
        }
    }
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/peer/peer.vue